import React from 'react'
import {
  TextField,
  InputLabel,
} from "material-ui";

const Duration = ({ translate, hours, minutes, seconds, errors, classes, onKeyDown, onInput, durationStart, durationEnd, disabled }) => {
  return (
    <div>
      <div>
        <br />
        <InputLabel htmlFor="sub_test_duration" style={{ fontSize: '14px', height: '5' }}>{translate('uptime_duration')}</InputLabel>
      </div>
      <TextField
        type="number"
        InputProps={{ inputProps: { min: 0, max: 23, onKeyDown: onKeyDown, onInput: onInput } }}
        style={{ width: 40 }}
        className={classes.textField}
        error={errors.duration}
        name="hours"
        margin="normal"
        value={hours}
        disabled={disabled}
      />
      {' : '}
      <TextField
        type="number"
        InputProps={{ inputProps: { min: 0, max: 59, onKeyDown: onKeyDown, onInput: onInput } }}
        style={{ width: 40 }}
        className={classes.textField}
        error={errors.duration}
        name="minutes"
        margin="normal"
        value={minutes}
        disabled={disabled}
      />
      {' : '}
      <TextField
        type="number"
        InputProps={{ inputProps: { min: 0, max: 59, step: 1, onKeyDown: onKeyDown, onInput: onInput } }}
        style={{ width: 40 }}
        className={classes.textField}
        error={errors.duration}
        name="seconds"
        margin="normal"
        value={seconds}
        disabled={disabled}
      />
      <div>
        {(!disabled && errors.duration) ? <InputLabel htmlFor="sub_test_duration" style={{ fontSize: '13px', height: '5', color: 'red' }}>{translate("subtest_number_range", { start: durationStart, end: durationEnd })}</InputLabel> : null}
      </div>
    </div>
  );
}

export default Duration
